<template>
    <div class="paket-list">
        <div v-for="(data, key) in dataList" :key="`card-paket-${key}`">
            <SOSlotCard
                :id="`card-${data.id}`"
                :card-type="'none'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:before_head>
                    <div
                        class="before-head-wrapper"
                        style="margin-bottom: 10px; padding-left: 2px; padding-right: 2px;"
                    >
                        <div
                            class="status-paket"
                            :class="{
                                sukses: getStatusPaket(data) === 'Sukses',
                                gagal: getStatusPaket(data) === 'Gagal',
                            }"
                        >
                            <label class="m-d-0 f-12 f-regular">
                                {{ getNamaPaket(data) }} • {{ getStatusPaket(data) }}
                            </label>
                        </div>
                    </div>
                </template>
                <template v-slot:card_head>
                    <div style="padding-left: 2px; padding-right: 2px;">
                        <label class="m-d-0">{{ data.paket.nama_paket }}</label>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div style="padding-left: 2px; padding-right: 2px;">
                        <div class="d-flex-between-center">
                            <div>
                                <label class="m-d-0">
                                    {{ data.paket.kuota }} Pesan / {{ data.paket.masa_aktif }} Hari
                                </label>
                            </div>
                            <div v-if="getStatusPaket(data) === 'Sukses'">
                                <label class="m-d-0">
                                    Aktif s.d. {{ $moment(data.paket.next_due).format("Do MMM YYYY") }}
                                </label>
                            </div>
                        </div>
                        <div class="d-flex-between-center">
                            <div>
                                <label class="m-d-0">
                                    {{ $moment(data.created_at).format("Do MMM YYYY HH:mm") }}
                                </label>
                            </div>
                            <div v-if="getStatusPaket(data) === 'Sukses'">
                                <label class="m-d-0">
                                    {{ metodeBayar(data.metode_bayar) }} {{ data.nominal | currency }}
                                </label>
                            </div>
                        </div>
                        <div v-if="getStatusPaket(data) === 'Gagal' && data.reason" class="p-t-8">
                            <label class="m-d-0">{{ data.reason }}</label>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
            <div class="p-x-20">
                <div class="separator-line"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import { moduleName } from "../store/state";

import metodeBayar from "../static/metodeBayar";

export default {
    name: "CardPaket",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            pagePaket: "pagePaket",
            endPaket: "endPaket",
            totalListPaket: "totalListPaket",
        }),
        getLastId() {
            return this.endPaket.id ? `card-${this.endPaket.id}` : "";
        },
        getStatusPaket() {
            return (data) => {
                return data.status === 1 ? "Sukses" : "Gagal";
            };
        },
        metodeBayar() {
            return (kode) => {
                let metodBayar = metodeBayar.find((mb) => mb.id == kode);

                return metodBayar?.title || "";
            };
        },
        getNamaPaket() {
            return (data) => {
                return data.tipe_bill === 1
                    ? "Pendaftaran"
                    : data.tipe_bill === 2
                    ? "Perpanjangan otomatis"
                    : "Pembelian paket";
            };
        },
    },
    methods: {
        ...mapActions({
            getRiwayatPaket: `${moduleName}/getRiwayatPaket`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayPaket: `${moduleName}/toggleDisplayPaket`,
        }),
        async doLoadMore() {
            if (this.totalListPaket > this.pagePaket.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.getRiwayatPaket({ idMesin: this.$route.params.id_device });
                }
            }
        },
        toggleCard(data) {
            this.toggleDisplayPaket(data);
        },
    },
};
</script>
<style scoped>
.status-paket {
    width: fit-content;
    padding: 0px 4px;
    border-radius: 3px;
}
.gagal {
    background-color: #fff1f1;
    color: #964040;
}
.sukses {
    background-color: #e8fcee;
    color: #40964c;
}
</style>
